// src/App.tsx
import React from "react";
import "./App.css";
import InProgress from "./InProgress";

const App: React.FC = () => {
  return (
    <div className="App">
      <InProgress />
    </div>
  );
};

export default App;
